import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/door/credentail/list', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/door/credentail/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/door/credentail/remove', qs.stringify(params), options);

export const add = (params, options) => request.post('/api/door/credentail/save', params, options);

export const update = (params, options) =>
  request.post('/api/door/credentail/submit', params, options);

//延期
export const delay = (params, options) =>
  request.post('/api/door/credentail/delay', params, options);
//领卡
export const collectCard = (params, options) =>
  request.post('/api/door/credentail/collectCard', params, options);

//根据小区id查询门禁信息
export const getDoorInfoByCommunityId = (communityId) => {
  return request({
    url: '/api/door/baseinfo/getDoorInfoByCommunityId',
    method: 'get',
    params: {
      communityId,
    },
  });
};

//根据小区id查询设备
export const getDeviceByCommunityId = (communityId) => {
  return request({
    url: '/api/door/device/getDeviceByCommunityId',
    method: 'get',
    params: {
      communityId,
    },
  });
};

//根据门禁id查询区域
export const getAreaByBaseInfoId = (baseInfoId) => {
  return request({
    url: '/api/door/devicearea/getAreaByBaseInfoId',
    method: 'get',
    params: {
      baseInfoId,
    },
  });
};

//根据小区id查询住户查询区域
export const getPerson = (propertyId) => {
  return request({
    url: '/api/base/household/getHouseholdByPropertyId',
    method: 'get',
    params: {
      propertyId,
    },
  });
};

//根据小区id查询住户查询区域
export const getPersonDetail = (id) => {
  return request({
    url: '/api/base/household/detail',
    method: 'get',
    params: {
      id,
    },
  });
};
//注销接口
export const cancel = (params, options) =>
  request.post('/api/door/credentail/cancel', params, options);
